/**
 * Atualização de perfil do admin: nome e telefone.
 * Nome é sincronizado com Firebase; telefone é armazenado localmente (pode ser migrado para API).
 */

import { updateProfile, type User } from 'firebase/auth';

const STORAGE_KEY = 'naviex-admin-profile-extras';

/** Mapa userId → telefone (e futuros extras) para sync com API. */
export function getAdminProfileExtras(): Record<string, string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Record<string, string>) : {};
  } catch {
    return {};
  }
}

function getStoredPhone(userId: string): string {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const data = raw ? (JSON.parse(raw) as Record<string, string>) : {};
    return data[userId] ?? '';
  } catch {
    return '';
  }
}

function setStoredPhone(userId: string, phone: string): void {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const data = raw ? (JSON.parse(raw) as Record<string, string>) : {};
    data[userId] = phone;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ [userId]: phone }));
  }
}

export function getAdminPhone(userId: string): string {
  return getStoredPhone(userId);
}

export async function updateAdminProfile(
  fbUser: User,
  updates: { name?: string; phone?: string }
): Promise<{ ok: boolean; error?: string }> {
  try {
    if (updates.name != null && updates.name.trim()) {
      await updateProfile(fbUser, { displayName: updates.name.trim() });
    }
    if (updates.phone != null) {
      setStoredPhone(fbUser.uid, updates.phone.trim());
    }
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : 'Erro ao atualizar perfil' };
  }
}
